export default __webpack_public_path__ + "static/media/Bura.4bd04025.png";